module.exports = __webpack_public_path__ + "static/media/3-th.37ee0d6.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/3-th.wav
// module id = YA0w
// module chunks = 1